import { Avatar, Button, Card, Row } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import Cargando from "../../components/Cargando";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";

const { Meta } = Card;
const Profesionales = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(true);
  const [psicologies, setPsicologies] = useState([]);

  const { usuario } = useContext(contextApp);

  const getProfesionales = async () => {
    setLoading(true);
    const response = Array.from(await getColection("Users")) || [];
    const filterPs = response.filter(
      (res) =>
        res.data.typeUser.value === "psicologo" && res.data.estado === true
    );
    setPsicologies(filterPs);

    setLoading(false);
    //setTopic(getdata.data.topic);
  };
  useEffect(() => {
    getProfesionales();
  }, [usuario]);

  return (
    <div>
      <Row gutter={16}>
        {loading && <Cargando />}
        {(psicologies || []).map((psychologist, index) => {
          return (
            <Card
              key={index}
              style={{
                width: 300,
                height: 150,
                marginTop: 16,
                marginLeft: 16,
              }}
            >
              {
                <Meta
                  avatar={
                    <Avatar
                      style={{ width: 80, height: 80 }}
                      src={psychologist.data.photoURL}
                    />
                  }
                  title={`${psychologist.data.name} ${psychologist.data.lastname}`}
                />
              }
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: -50,
                  gap: 10,
                }}
              >
                <Button
                  style={{
                    backgroundColor: "white",
                  }}
                  onClick={() => {
                    history.push(`/informacion/${psychologist.data.name}`, {
                      psychologist,
                    });
                  }}
                >
                  Información
                </Button>{" "}
                <Button
                  onClick={() => {
                    history.push(`/agenda/${psychologist.data.name}`, {
                      psychologist,
                    });
                  }}
                >
                  Agendar cita
                </Button>
              </div>
            </Card>
          );
        })}
      </Row>
    </div>
  );
};

export default Profesionales;
